// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('[data-add-to-cart]');
//   if (!btn || btn.classList.contains('is-loading')) return;

//   const item = btn.closest('.complete-the-look__item');
//   if (!item) return;

//   const sizeSelect = item.querySelector('[data-size-select]');
//   const jsonEl = item.querySelector('.variant-json');
//   if (!sizeSelect || !jsonEl || !sizeSelect.value) return;

//   const variants = JSON.parse(jsonEl.textContent);
//   const variant = variants.find(v => v.available && v.options.includes(sizeSelect.value));
//   if (!variant) return;

//   // DISABLE BUTTON + CHANGE TEXT
//   const originalText = btn.textContent;
//   btn.classList.add('is-loading');
//   btn.disabled = true;
//   btn.textContent = 'Adding to cart…';

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ id: variant.id, quantity: 1 })
//   })
//     .then(() => {
//       // OPEN DRAWER
//       const discountBtn = document.querySelector('.js-cart-discount-apply-button');
//       const cartBtn = document.querySelector('.js-header-cart-toggler');
//       if (cartBtn) cartBtn.click();
//       if (discountBtn) discountBtn.click();
//     })
//     .catch(() => {
//       // optional: error handling (kept minimal)
//     })
//     .finally(() => {
//       //  ENABLE BUTTON + RESTORE TEXT
//       btn.disabled = false;
//       btn.classList.remove('is-loading');
//       btn.textContent = originalText;
//     });
// });

















document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn || btn.classList.contains('is-loading')) return;

  const item = btn.closest('.complete-the-look__item');
  if (!item) return;

  const sizeSelect = item.querySelector('[data-size-select]');
  const jsonEl = item.querySelector('.variant-json');
  if (!sizeSelect || !jsonEl) return;

  const variants = JSON.parse(jsonEl.textContent);

  const size = sizeSelect.value;

  //  No size selected
  if (!size) return;

  //  ONLY AVAILABLE VARIANT
  const variant = variants.find(
    v => v.available && v.options.includes(size)
  );

  //  SOLD OUT
  if (!variant) {
    btn.textContent = 'Sold out';
    btn.disabled = true;
    btn.classList.add('is-disabled');
    return;
  }

  //  DISABLE BUTTON + CHANGE TEXT
  const originalText = btn.dataset.originalText || btn.textContent;
  btn.dataset.originalText = originalText;

  btn.classList.add('is-loading');
  btn.disabled = true;
  btn.textContent = 'Adding to cart…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variant.id, quantity: 1 })
  })
    .then(() => {
      // OPEN DRAWER (SAME AS BEFORE)
      const discountBtn = document.querySelector('.js-cart-discount-apply-button');
      const cartBtn = document.querySelector('.js-header-cart-toggler');
      if (cartBtn) cartBtn.click();
      if (discountBtn) discountBtn.click();
    })
    .finally(() => {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
    });
});

/* ===============================
   SIZE CHANGE → BUTTON STATE FIX
================================ */
document.addEventListener('change', function (e) {
  const sizeSelect = e.target.closest('[data-size-select]');
  if (!sizeSelect) return;

  const item = sizeSelect.closest('.complete-the-look__item');
  if (!item) return;

  const btn = item.querySelector('[data-add-to-cart]');
  const jsonEl = item.querySelector('.variant-json');
  if (!btn || !jsonEl) return;

  const variants = JSON.parse(jsonEl.textContent);
  const size = sizeSelect.value;

  const variant = variants.find(
    v => v.available && v.options.includes(size)
  );

  if (!variant) {
    btn.textContent = 'Sold out';
    btn.disabled = true;
    btn.classList.add('is-disabled');
  } else {
    btn.textContent = btn.dataset.originalText || 'Add to cart';
    btn.disabled = false;
    btn.classList.remove('is-disabled');
  }
});
